module.exports = __webpack_public_path__ + "static/media/uncheckcyan.fb896adb.svg";